<div class="modal-css modal-xl">
    <div class="modal-header">
      <h2 class="modal-title" id="exampleModalLabel">{{ 'answerList' | translate }}</h2>
      <button type="button" class="btn" (click)="modalRef.close()">
        <img src="./assets/icon/close.svg" alt="Icona" />
      </button>
    </div>
    <div class="modal-body">
      <div class="table-responsive">
        <table class="table">
          <thead>
            <tr>
              <th colspan="2">{{ 'questions' | translate }}</th>
              <th>{{ 'answers' | translate }}</th>
              <th>CAIDE</th>
            </tr>
          </thead>
          <tbody *ngIf="responses != null">
            <tr *ngFor="let response of responses">
              <td><p>#{{ response.step }}</p></td>
              <td class="fixed-cell"><p>{{ response.question }}</p></td>
              <td class="fixed-cell"><p>{{ response.response }}</p></td>
              <td class="td-center blue"><p>{{ response.score }}</p></td>
            </tr>
          </tbody>
          <tbody *ngIf="responses == null">
            <tr *ngFor="let number of numbers">
              <td><p>#{{ number }}</p></td>
              <td class="fixed-cell"><p>{{ 'charging' | translate }}</p></td>
              <td class="fixed-cell"><p>{{ 'charging' | translate }}</p></td>
              <td class="td-center blue"><p>-</p></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
</div>